import {CustomFieldValueApiDto} from "../../api/model/rest";
import {none, Option, option} from "ts-option";
import JsonConverter from "../../api/helper/JsonConverter";

export default class CustomFieldValue {
	/**
	 * Custom field value data object
	 * @param {Option<string>} id
	 * @param {string} customFieldId
	 * @param {Option<string>} value
	 */
	constructor(public readonly id: Option<string>,
		public readonly customFieldId: string,
		public readonly value: Option<string>) {}


	public static fromJson(json: CustomFieldValueApiDto): CustomFieldValue {
		const id = json.id ? option(json.id) : none;
		const customFieldId = json.customFieldId;
		const value = json.value ? option(json.value) : none;

		return new CustomFieldValue(id, customFieldId, value);
	}

	toJson(): CustomFieldValueApiDto {
		const json: CustomFieldValueApiDto = {
			id: this.id.orNull,
			customFieldId: this.customFieldId,
			value: this.value.orNull
		};
		return JsonConverter.removeEmptyFields(json);
	}

	copy({value = this.value}){
		return new CustomFieldValue(this.id, this.customFieldId, value)
	}
}